module.exports = __webpack_public_path__ + "img/tablet-pastelaria.ec1bf765.png";